export default __webpack_public_path__ + "static/media/talksCardBack.7dc8695e.svg";